import React from "react";
import { Link } from "react-router-dom";
import {
  FaPaperPlane,
  FaUsers,
  FaUserShield,
  FaTachometerAlt,
  FaLink,
  FaMapMarkedAlt,
  FaCog,
  FaDatabase,
  FaThLarge,
} from "react-icons/fa";

const QUICK_ACTIONS = [
  {
    label: "Nueva Emisión",
    path: "/emissions",
    icon: FaPaperPlane,
    color: "#1F2B68",
  },
  {
    label: "Gestión de Usuarios",
    path: "/users-management",
    icon: FaUsers,
    color: "#0284C7",
  },
  {
    label: "Gestión de Roles",
    path: "/roles",
    icon: FaUserShield,
    color: "#2563EB",
  },
  {
    label: "Consola NOC / Monitoreo",
    path: "/monitoring",
    icon: FaTachometerAlt,
    color: "#D97706",
  },
  {
    label: "Interoperabilidad",
    path: "/interoperability",
    icon: FaLink,
    color: "#1B8F4D",
  },
  {
    label: "Consulta Catastral",
    path: "/cadastral",
    icon: FaMapMarkedAlt,
    color: "#DB2777",
  },
  {
    label: "Datamart",
    path: "/datamart",
    icon: FaDatabase,
    color: "#7C3AED",
  },
  {
    label: "Configuración Global",
    path: "/system-configurations",
    icon: FaCog,
    color: "#475569",
  },
];

export default function SuperadminQuickActions() {
  return (
    <div className="sad-quick-actions-card">
      <div className="sad-section-header">
        <span className="sad-section-title">
          <FaThLarge className="text-primary" /> Acciones Rápidas del Superadmin
        </span>
      </div>

      <div
        className="sad-actions-grid"
        role="region"
        aria-label="Acciones rápidas disponibles"
      >
        {QUICK_ACTIONS.map((action, idx) => {
          const Icon = action.icon;
          return (
            <Link
              key={idx}
              to={action.path}
              className="sad-action-btn"
              style={{ "--action-color": action.color }}
            >
              <span className="sad-action-icon">
                <Icon />
              </span>
              <span>{action.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
